/// <reference types="@types/googlemaps" />
import { AfterContentInit, AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MarkerWithLabel } from '@googlemaps/markerwithlabel';
import { interval, Observable, Subscription } from 'rxjs';
import {COMMA, ENTER, V} from '@angular/cdk/keycodes';
import { MatFormField } from '@angular/material/form-field';
import { MatChipInputEvent } from '@angular/material/chips';
 
import * as moment from 'moment';
import { Router } from '@angular/router';

declare var google: any;
declare var $: any;

@Component({
    selector: 'dashboard-cmp',
    moduleId: module.id,
    templateUrl: 'dashboard.component.html'
})

export class DashboardComponent implements OnInit{

    @ViewChildren('cardItem') cardItem: QueryList<any>;
    @ViewChild('historyMap' , {static: false}) historyMapElement: ElementRef;
    @ViewChild('histo-right', {static: false}) historyRightPanelElement: ElementRef;

    addOnBlur = true;
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    emails: any = [];

    loading: boolean = true;

    allDevices: any = [];
    allDeviceCopy: any = [];
    allUpdatedDevices: any;
    allMaps: any = [];
    allPanoramas: any = [];
    allMarkers: any = [];
    allCircles: any = [];

    singleMap: any;
    singlePanorama: any;
    allSingleMarkers: any = [];

    refreshInterval: any;
    subscription: any;

    cardChangeSub: Subscription;

    lastOccurTs: any;

    viewMode: any = false;

    search: any = "";
    searchSingleMap: any = "";

    currSelectedDev: any = "";
    alertDevID: any = "-1";
    alertPhNbr: any = "";

    addStolenSuccess: boolean = false;

    currentEditDevice: any;
    editDeviceName: any = "";

    timerSub: any;
    timerVal: any = 60;

    constructor(private http: HttpClient, private matFormField: MatFormField,private router: Router){ }

    ngOnInit(){
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.getDevices();
        const source = interval(60000);
        const timerSource = interval(1000);
        this.subscription = source.subscribe(val => this.updateDevicesData());
        this.timerSub = timerSource.subscribe(val => {
            this.timerVal--;
        });

        let that = this;
        $('#historyModal').on('hidden.bs.modal', function () {
            that.resetHistoryFields();    
        });

        let tmpDisplayMode = localStorage.getItem('displayMode');
        this.emails.push(localStorage.getItem('username'));

        if(tmpDisplayMode == "0"){
            this.viewMode = false;
        }else if(tmpDisplayMode == "1"){
            this.viewMode = true;
            //this.initSingleMap();
        }
        
    }

    ngAfterViewInit() {
        let that = this;
        window.addEventListener("load", function(event) {
            if(screen.width > 400){
                that.adjustHistoryModalHeight();
            }
        });
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our fruit
        if (value) {
          this.emails.push(value);
        }
    
        // Clear the input value
        event.input.value = "";
    }
    
    remove(email): void {
        const index = this.emails.indexOf(email);
    
        if (index >= 0) {
          this.emails.splice(index, 1);
        }
    }

    toggleViewMode(){
        if(this.viewMode){
            this.initSingleMap();
        }
        this.saveUserPreferences();
    }

    saveUserPreferences(){
        let tmpDM = 0;
        if(this.viewMode){
            tmpDM = 1;
        }
        else{
            tmpDM = 0;
        }
        localStorage.setItem('displayMode', tmpDM.toString());
    }

    adjustHistoryModalHeight(){
        console.log(document.getElementById("historyMap"));
        let height = document.body.clientHeight;
        let historyModalHeight = height * 0.8;
        document.getElementById("historyMap").style.height = historyModalHeight + "px";
        document.getElementById("histo-right").style.height = historyModalHeight + "px";
    }

    getDevices(){
        this.loading = true;
        let headers = {'Authorization': 'Bearer ' + localStorage.getItem("accessToken")};
        this.http.get<any>('https://admin.iot-tracking.com/api/v2/devices/dashboard?groupId='+ localStorage.getItem("groupId") +'&searchTree=true', {headers}).subscribe((data) => {
            for(let i =0; i<data.data.length; i++){
                for(let j=0; j<data.data[i].trackedKeys.length; j++){
                    if(data.data[i].trackedKeys[j].key =="mac1"){
                        data.data[i].mac1 = data.data[i].trackedKeys[j].value
                    }else if(data.data[i].trackedKeys[j].key =="mac2"){
                        data.data[i].mac2 = data.data[i].trackedKeys[j].value
                    }else if(data.data[i].trackedKeys[j].key =="mac3"){
                        data.data[i].mac3 = data.data[i].trackedKeys[j].value
                    }
                }
            }
            console.log(data.data);
            this.allDevices = data.data;
            this.allDeviceCopy = data.data;

            this.cardChangeSub = this.cardItem.changes.subscribe(t => {
                this.setupMaps();
            });
            if(this.viewMode){
                this.initSingleMap();
            }

            this.loading = false;
        }, (error) => {
            if(error.status == 401){
                this.loading = false;
                //this.refreshToken();
                this.logout();
            }
            if(error.status == 500){
                this.loading = false;
            }
        });
    }

    updateDevicesData(){
        this.timerVal = 60;
        this.cardChangeSub.unsubscribe();
        let headers = {'Authorization': 'Bearer ' + localStorage.getItem("accessToken")};
        this.http.get<any>('https://admin.iot-tracking.com/api/v2/devices/dashboard?groupId='+ localStorage.getItem("groupId") +'&searchTree=true', {headers}).subscribe((data) => {
            this.allUpdatedDevices = data.data;

            for(var t = 0; t < this.allUpdatedDevices.length; t++){
                for(var k = 0; k < this.allDevices.length; k++){
                    if(this.allUpdatedDevices[t].id == this.allDevices[k].id){
                        this.allDevices[k].name = this.allUpdatedDevices[t].name;
                        this.allDevices[k].batteryLevel = this.allUpdatedDevices[t].batteryLevel;
                        this.allDevices[k].lastDataMessage = this.allUpdatedDevices[t].lastDataMessage;
                        this.allDevices[k].lastSourceBasedLocation = this.allUpdatedDevices[t].lastSourceBasedLocation;
                        this.allDevices[k].lqi = this.allUpdatedDevices[t].lqi;
                        this.allDevices[k].trackedKeys = this.allUpdatedDevices[t].trackedKeys;
                    }
                }
                if(t == this.allUpdatedDevices.length - 1){
                    this.updateMaps();
                }
            }

            this.loading = false;
        }, (error) => {
            if(error.status == 401){
                this.loading = false;
                //this.refreshToken();
                this.logout();
            }
            if(error.status == 500){
                this.loading = false;
            }
        });
    }

    initSingleMap(){
        this.allSingleMarkers = [];

        var mapOptions = {
            zoom: 15,
            controlSize: 25,
            fullscreenControl: false,
            streetViewControl: false
        }
        var map = new google.maps.Map(document.getElementById("map-single"), mapOptions);
        this.singleMap = map;

        let panorama: google.maps.StreetViewPanorama;
        this.singlePanorama = panorama;

        for(var n = 0; n < this.allDevices.length; n++){
            var lat = this.allDevices[n].lastSourceBasedLocation?.lat;
            var lon = this.allDevices[n].lastSourceBasedLocation?.lng;

            var myLatlng;
            if(typeof this.allDevices[n].lastSourceBasedLocation !== 'undefined'){
                myLatlng = new google.maps.LatLng(lat, lon);
            }
            else{
                myLatlng = new google.maps.LatLng(0, 0);
            }

            let today = moment(new Date());
            let dateLastReport = moment(this.allDevices[n].lastDataMessage?.created);
            let minDiff = today.diff(dateLastReport, 'minutes');

            let timeToShow = "";

            if (typeof this.allDevices[n].lastDataMessage !== 'undefined'){
                this.allDevices[n].lastDataMessage.minDiff = minDiff;
                timeToShow = minDiff + "m ago";

                if(minDiff > 60){
                    this.allDevices[n].lastDataMessage.hDiff = Math.floor(minDiff/60);
                    timeToShow = Math.floor(minDiff/60) + "h ago";
                }
                else{
                    this.allDevices[n].lastDataMessage.hDiff = "";
                }
            }

            var marker;

            if(this.allDevices[n].lastSourceBasedLocation?.locationSource == "data_wifi"){
                marker = new MarkerWithLabel({
                    position: myLatlng,
                    map: map,
                    labelContent: '<span class="label-with-acc"><span id="markerDeviceName">' + this.allDevices[n].name + '</span><br>' + timeToShow + '</span>',
                    labelClass: "labels",
                    labelAnchor: new google.maps.Point(((this.allDevices[n].name).length*(-3)), 0)
                });
    
                this.allSingleMarkers.push(marker);
                this.allSingleMarkers[n].minDiff = minDiff;

                marker.setIcon('../assets/img/wifi.png');
            }
            else{
                let radius = 0;

                for(var j = 0; j < this.allDevices[n].trackedKeys.length; j++){
                    if(this.allDevices[n].trackedKeys[j].key == "radius"){
                        radius = this.allDevices[n].trackedKeys[j].value;
                    }
                }

                marker = new MarkerWithLabel({
                    position: myLatlng,
                    map: map,
                    labelContent: '<span class="label-with-acc"><span id="markerDeviceName">' + this.allDevices[n].name + '</span><br>' + radius + 'm - ' + timeToShow + '</span>',
                    labelClass: "labels",
                    labelAnchor: new google.maps.Point(((this.allDevices[n].name).length*(-3)), 0)
                });
    
                this.allSingleMarkers.push(marker);
                this.allSingleMarkers[n].minDiff = minDiff;

                marker.setIcon('../assets/img/atlas.png');
            }

            marker.setMap(map);
        }

        this.allDevices.sort(function(a, b) {
            var keyA = a.lastDataMessage?.minDiff,
                keyB = b.lastDataMessage?.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allSingleMarkers.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < this.allSingleMarkers.length; i++) {
            var position = this.allSingleMarkers[i].position;
            bounds.extend(position);
        }
        map.fitBounds(bounds);
        map.panToBounds(bounds);
        this.createListeners();
    }

    createListeners(){
        for(var f = 0; f < this.allSingleMarkers.length; f++){
            const tmpMarker = this.allSingleMarkers[f];
            tmpMarker.addListener("click", () => {
                this.singleMap.setZoom(16);
                document.querySelectorAll(".single-map-dev-name").forEach(function(elmt:any){
                    if(elmt.innerText == tmpMarker.label.labelDiv.querySelector("#markerDeviceName").innerText){
                        elmt.scrollIntoView({ behavior: 'smooth' });
                        elmt.click();
                    }
                })
                
                this.singleMap.setCenter(tmpMarker.getPosition() as google.maps.LatLng);
            });
        }
    }

    setupMaps(){
        this.allMaps = [];
        this.allPanoramas = [];
        this.allMarkers = [];
        this.allCircles = [];
        for(var o = 0; o < this.allDevices.length; o++){

            let today = moment(new Date());
            let dateLastReport = moment(this.allDevices[o].lastDataMessage?.created);
            let minDiff = today.diff(dateLastReport, 'minutes');

            if (typeof this.allDevices[o].lastDataMessage !== 'undefined'){
                this.allDevices[o].lastDataMessage.minDiff = minDiff;

                if(minDiff > 60){
                    this.allDevices[o].lastDataMessage.hDiff = Math.floor(minDiff/60);
                }
                else{
                    this.allDevices[o].lastDataMessage.hDiff = "";
                }
            }

            let panorama: google.maps.StreetViewPanorama;

            var elmtID = "map" + this.allDevices[o].id;

            var lat = this.allDevices[o].lastSourceBasedLocation?.lat;
            var lon = this.allDevices[o].lastSourceBasedLocation?.lng;

            var myLatlng;
            if(typeof this.allDevices[o].lastSourceBasedLocation !== 'undefined'){
                myLatlng = new google.maps.LatLng(lat, lon);
            }
            else{
                myLatlng = new google.maps.LatLng(0, 0);
            }

            var mapOptions = {
              zoom: 15,
              center: myLatlng,
              controlSize: 25,
              fullscreenControl: false,
              mapTypeControl: false,
              streetViewControl: false
            }
            var map = new google.maps.Map(document.getElementById(elmtID), mapOptions);
            this.allMaps.push(map);
            this.allMaps[o].minDiff = minDiff;

            var marker = new MarkerWithLabel({
                position: myLatlng,
                map: map,
                labelContent: "",
                labelAnchor: new google.maps.Point(-47, 0)
            });

            this.allMarkers.push(marker);
            this.allMarkers[o].minDiff = minDiff;

            if(this.allDevices[o].lastSourceBasedLocation?.locationSource == "data_wifi"){
                marker.setIcon('../assets/img/wifi.png');

                const circle = new google.maps.Circle({
                    strokeColor: "#03a9f4",
                    strokeOpacity: 0,
                    strokeWeight: 0,
                    fillColor: "#03a9f4",
                    fillOpacity: 0,
                    map,
                    center: myLatlng,
                    radius: 0,
                });

                this.allCircles.push(circle);
                this.allCircles[o].minDiff = minDiff;

                for(var j = 0; j < this.allDevices[o].trackedKeys.length; j++){
                    if(this.allDevices[o].trackedKeys[j].key == "battery"){
                        this.allDevices[o].battVal = this.allDevices[o].trackedKeys[j].value;
                    }
                }
            }
            else{
                marker.setIcon('../assets/img/atlas.png');
                marker.set("labelClass", "labels");

                let radius = 0;

                for(var j = 0; j < this.allDevices[o].trackedKeys.length; j++){
                    if(this.allDevices[o].trackedKeys[j].key == "radius"){
                        radius = this.allDevices[o].trackedKeys[j].value;
                    }
                    if(this.allDevices[o].trackedKeys[j].key == "battery"){
                        this.allDevices[o].battVal = this.allDevices[o].trackedKeys[j].value;
                    }
                }

                marker.set("labelContent", "Accuracy: " + radius + "m");

                const circle = new google.maps.Circle({
                    strokeColor: "#03a9f4",
                    strokeOpacity: 0,
                    strokeWeight: 2,
                    fillColor: "#03a9f4",
                    fillOpacity: 0.2,
                    map,
                    center: myLatlng,
                    radius: radius,
                });

                this.allCircles.push(circle);
                this.allCircles[o].minDiff = minDiff;

                if(radius > 0 && radius <= 2000){
                    map.setZoom(12);
                }
                else if(radius > 2000 && radius <= 4000){
                    map.setZoom(11.5);
                }
                else if(radius > 4000 && radius <= 6000){
                    map.setZoom(11);
                }
                else if(radius > 6000 && radius <= 8000){
                    map.setZoom(10.5);
                }
                else if(radius > 8000 && radius <= 10000){
                    map.setZoom(10);
                }
                else if(radius > 10000 && radius <= 12000){
                    map.setZoom(9.5);
                }
                else{
                    map.setZoom(9);
                }
            }

            panorama = map.getStreetView()!;
            panorama.setPosition(myLatlng);
            panorama.setPov(
                /** @type {google.maps.StreetViewPov} */ {
                heading: 265,
                pitch: 0,
            });

            this.allPanoramas.push(panorama);
            this.allPanoramas[o].minDiff = minDiff;

            marker.setMap(map);
        }

        this.allDevices.sort(function(a, b) {
            var keyA = a.lastDataMessage?.minDiff,
                keyB = b.lastDataMessage?.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allMaps.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allMarkers.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allPanoramas.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allCircles.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });
    }

    updateMaps(){
        for(var o = 0; o < this.allDevices.length; o++){

            let today = moment(new Date());
            let dateLastReport = moment(this.allDevices[o].lastDataMessage?.created);
            let minDiff = today.diff(dateLastReport, 'minutes');

            let timeToShow = "";

            if (typeof this.allDevices[o].lastDataMessage !== 'undefined'){
                this.allDevices[o].lastDataMessage.minDiff = minDiff;
                timeToShow = minDiff + "m ago";

                if(minDiff > 60){
                    this.allDevices[o].lastDataMessage.hDiff = Math.floor(minDiff/60);
                    timeToShow = Math.floor(minDiff/60) + "h ago";
                }
                else{
                    this.allDevices[o].lastDataMessage.hDiff = "";
                }
            }

            var lat = this.allDevices[o].lastSourceBasedLocation?.lat;
            var lon = this.allDevices[o].lastSourceBasedLocation?.lng;

            var myLatlng;
            if(typeof this.allDevices[o].lastSourceBasedLocation !== 'undefined'){
                myLatlng = new google.maps.LatLng(lat, lon);
            }
            else{
                myLatlng = new google.maps.LatLng(0, 0);
            }

            this.allMaps[o].setCenter(myLatlng);
            this.allMaps[o].minDiff = minDiff;

            this.allMarkers[o].setPosition(myLatlng);
            this.allMarkers[o].minDiff = minDiff;

            if(this.allSingleMarkers[o] != "" && this.allSingleMarkers[o] != null){
                this.allSingleMarkers[o].setPosition(myLatlng);
                this.allSingleMarkers[o].minDiff = minDiff;

                if(this.allDevices[o].lastSourceBasedLocation?.locationSource == "data_wifi"){
                    this.allSingleMarkers[o].setIcon('../assets/img/wifi.png');
                    this.allSingleMarkers[o].set("labelClass", "labels");
                    this.allSingleMarkers[o].set("labelContent", '<span class="label-with-acc"><span id="markerDeviceName">' + this.allDevices[o].name + '</span><br>' + timeToShow + '</span>');

                    for(var j = 0; j < this.allDevices[o].trackedKeys.length; j++){
                        if(this.allDevices[o].trackedKeys[j].key == "battery"){
                            this.allDevices[o].battVal = this.allDevices[o].trackedKeys[j].value;
                        }
                    }
                }
                else{
                    let radius = 0;

                    for(var j = 0; j < this.allDevices[o].trackedKeys.length; j++){
                        if(this.allDevices[o].trackedKeys[j].key == "radius"){
                            radius = this.allDevices[o].trackedKeys[j].value;
                        }
                        if(this.allDevices[o].trackedKeys[j].key == "battery"){
                            this.allDevices[o].battVal = this.allDevices[o].trackedKeys[j].value;
                        }
                    }

                    this.allSingleMarkers[o].setIcon('../assets/img/atlas.png');
                    this.allSingleMarkers[o].set("labelClass", "labels");
                    this.allSingleMarkers[o].set("labelContent", '<span class="label-with-acc"><span id="markerDeviceName">' + this.allDevices[o].name + '</span><br>' + radius + 'm - ' + timeToShow + '</span>');
                }
            }

            if(this.allDevices[o].lastSourceBasedLocation?.locationSource == "data_wifi"){
                this.allMarkers[o].setIcon('../assets/img/wifi.png');
                this.allMarkers[o].set("labelClass", "labels_wifi");
                this.allMarkers[o].set("labelContent", "");

                this.allCircles[o].minDiff = minDiff;
                this.allCircles[o].setVisible(false);
            }
            else{
                this.allMarkers[o].setIcon('../assets/img/atlas.png');
                this.allMarkers[o].set("labelClass", "labels");

                let radius = 0;

                for(var j = 0; j < this.allDevices[o].trackedKeys.length; j++){
                    if(this.allDevices[o].trackedKeys[j].key == "radius"){
                        radius = this.allDevices[o].trackedKeys[j].value;
                    }
                }

                this.allMarkers[o].set("labelContent", "Accuracy: " + radius + "m");

                this.allCircles[o].setOptions({
                    strokeColor: "#03a9f4",
                    strokeOpacity: 0,
                    strokeWeight: 2,
                    fillColor: "#03a9f4",
                    fillOpacity: 0.2,
                    center: myLatlng,
                    radius: radius,
                });

                this.allCircles[o].minDiff = minDiff;

                this.allCircles[o].setVisible(true);

                if(radius > 0 && radius <= 2000){
                    this.allMaps[o].setZoom(12);
                }
                else if(radius > 2000 && radius <= 4000){
                    this.allMaps[o].setZoom(11.5);
                }
                else if(radius > 4000 && radius <= 6000){
                    this.allMaps[o].setZoom(11);
                }
                else if(radius > 6000 && radius <= 8000){
                    this.allMaps[o].setZoom(10.5);
                }
                else if(radius > 8000 && radius <= 10000){
                    this.allMaps[o].setZoom(10);
                }
                else if(radius > 10000 && radius <= 12000){
                    this.allMaps[o].setZoom(9.5);
                }
                else{
                    this.allMaps[o].setZoom(9);
                }
            }

            this.allPanoramas[o] = this.allMaps[o].getStreetView()!;
            this.allPanoramas[o].setPosition(myLatlng);
            this.allPanoramas[o].setPov(
                /** @type {google.maps.StreetViewPov} */ {
                heading: 265,
                pitch: 0,
            });
            this.allPanoramas[o].minDiff = minDiff;
        }

        this.allDevices.sort(function(a, b) {
            var keyA = a.lastDataMessage?.minDiff,
                keyB = b.lastDataMessage?.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allMaps.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allMarkers.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allPanoramas.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allCircles.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        this.allSingleMarkers.sort(function(a, b) {
            var keyA = a.minDiff,
                keyB = b.minDiff;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });
    }

    showAll(){
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < this.allSingleMarkers.length; i++) {
            var position = this.allSingleMarkers[i].position;
            bounds.extend(position);
        }
        this.singleMap.fitBounds(bounds);
        this.singleMap.panToBounds(bounds);
    }

    toggleStreetView(mapObjIdx){
        const toggle = (this.allPanoramas[mapObjIdx]).getVisible();

        if (toggle == false) {
            (this.allPanoramas[mapObjIdx]).setVisible(true);
        } else {
            (this.allPanoramas[mapObjIdx]).setVisible(false);
        }
    }

    currentHistory:any;
    rawCurrentHistory:any;
    histoStart = moment().format("YYYY-MM-DD");
    histoEnd = moment().format("YYYY-MM-DD");
    histoWifi = true;
    histoAtlas = false;
    histoCurrentId:any;
    histoCount = 0;
    historyMap:any;
    infowindowArray = [];
    histoPosDisplay = false;
    

    getHistory(id){
        this.histoCurrentId = id;
        this.loading = true;
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
        };
        let histoStartValue = moment(this.histoStart).format("YYYY-MM-DDT00:00");
        let histoEndValue = moment(this.histoEnd).format("YYYY-MM-DDT23:59");
        this.http.get<any>('https://admin.iot-tracking.com/api/v2/devices/'+id+'/messages/?timestampFrom='+ moment(histoStartValue).format("X") +'&timestampTo='+moment(histoEndValue).format("X")+'&limit=1000' ,{headers}).subscribe((data) => {
            this.loading = false;
            if(data.length != 0){
                this.rawCurrentHistory = data;
                this.formatHistoData();
            }
        }, (error) => {
            this.loading = false;
            console.log(error);
        });
    }

    formatHistoData(){
        //FORMAT DATA ARRAY
        let newData = [];
        this.rawCurrentHistory.data.forEach((element) => {
            let obj = {};
            obj["dateValue"] = moment.unix(element.timestamp).format("DD/MM/YYYY HH:mm");
            element.keys.forEach(key => {
                if(key.key == "action"){
                    if(this.histoWifi == true && ( key.value == "position" || key.value == "stopped_position" || key.value == "moving_position" || key.value == "start_of_movement_position")){
                        obj["action"] = key.valueLocale;
                    }
                    if(this.histoAtlas == true && key.value == "atlas_position_network"){
                        obj["action"] = key.valueLocale;
                    }
                }
                if(key.key == "radius"){
                    obj["radius"] = key.valueLocale;
                }
                if(key.key == "latitude"){
                    obj["latitude"] = key.value;
                }
                if(key.key == "longitude"){
                    obj["longitude"] = key.value;
                }
            });
            if(obj["action"] != null && obj["longitude"] != null && obj["latitude"] != null){
                newData.push(obj);
            }
        });

        //SAVE DATA FORMATTED
        this.currentHistory = newData;
        this.histoCount = newData.length;
        this.initHistoMap();
    }

    initStolenModal(devID){
        this.alertDevID = devID;
    }

    saveNewAlert(){
        if(this.alertDevID != "-1" && this.emails.length > 0){
            this.loading = true;
            let headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
            };
            let body = {
                rule: {
                    deviceIds: [this.alertDevID],
                    useDeviceTimezone: false,
                    forTree: false,
                    tagIds: [],
                    groupId: localStorage.getItem("groupId"),
                    name: this.alertDevID,
                    notifSubject: "{deviceName} ({deviceId}) notification",
                    notifMessage: "Your device {deviceName} has triggered a {action} at {time}.",
                    notifContacts: this.emails,
                    allDevices: false,
                    isActive: true,
                    timezone: "Europe/Paris",
                    timeLimit: {
                        from: "00:00",
                        to: "23:59",
                        mon: true,
                        tue: true,
                        wed: true,
                        thu: true,
                        fri: true,
                        sat: true,
                        sun: true
                    },
                    locale: "en",
                    notifChannel: "email",
                    deviceType: "simple_pack_plus_wifi_3_0_6_0",
                    rule: "{\"any\":[{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"position\"},{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"stopped_position\"},{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"moving_position\"},{\"fact\":\"action\",\"operator\":\"equal\",\"value\":\"start_of_movement_position\"}]}"
                
                }
            };
            this.http.post<any>('https://admin.iot-tracking.com/api/v2/groups/'+ localStorage.getItem("groupId") + '/rules?locale=fr', body ,{headers}).subscribe((data) => {
                this.loading = false;
                $('#addToStolenModal').modal('hide');
                this.addStolenSuccess = true;
                setTimeout(() => { this.addStolenSuccess = false; }, 3000);
            }, (error) => {
                this.loading = false;
                console.log(error);
            });
        }
        else{
            alert('Please select a device and fill in a phone number in the right format.');
        }
    }

    initHistoMap(){
        //INIT GOOGLE MAP
        var mapOptions = {
            zoom: 15,
            scrollwheel: true,
            controlSize: 25,
            fullscreenControl: false
        }
        this.historyMap = new google.maps.Map(document.getElementById("historyMap"), mapOptions);

        //CREATE GOOGLE MAP POLYLINES MARKERS INFOWINDOWS
        let polyLatLng = [];
        let markersArray = [];
        let map = this.historyMap;
        let count = 0;
        this.currentHistory.forEach((element, index) =>{
            //INFOWINDOW
            //OPTIONS
            var infowindow = new google.maps.InfoWindow({
                content: "<p style='font-weight: 600; margin: 3px;'>"+element.action + "</p>",
            });
            this.infowindowArray.push(infowindow);
            let color = "#03A9F4";
            if(element.action == "Position"){
                color = "#2ECC71";
            }else if(element.action == "Atlas network position"){
                color = "#E74C3C";
            }
            element['color'] = color;
            element['display'] = "block";
            
            //MARKER
            let markerExist = false;
            if(polyLatLng.length > 0){
                for (let i = 0; i < markersArray.length; i++) {
                    if(markersArray[i].getPosition().lat() == element.latitude && markersArray[i].getPosition().lng() == element.longitude){
                        markerExist = true;
                        element['marker'] = markersArray[i];
                        element['color'] = "#1F3C8F";
                        if(!this.histoPosDisplay){
                            element['display'] = "none";
                        }
                    }
                }
            }
            if(!markerExist){
                count++;
                let latLng = new google.maps.LatLng(element.latitude, element.longitude);
                //OPTIONS
                var marker = new google.maps.Marker({
                    position: latLng,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        fillColor: color,
                        fillOpacity: 0.9,
                        strokeColor: color,
                        strokeOpacity: 0.9,
                        strokeWeight: 1,
                        scale: 7
                    }
                });
                //ON CLICK
                marker.addListener("click", (e) => {
                    this.infowindowArray.forEach(element => {
                        element.close();
                    });
                    infowindow.open({
                        anchor: marker,
                        map,
                        shouldFocus: false,
                    });
                    if(e != "fromList"){
                        document.getElementById("historyLine-"+index).scrollIntoView({ behavior: 'smooth' });
                        document.getElementById("historyLine-"+index).click();
                    }                            
                });
                //ADD MARKER
                markersArray.push(marker);
                element['marker'] = marker;
                marker.setMap(map);
            }
            //POLYLINES
            //COORDINATES
            polyLatLng.push({
                lat : element.latitude,
                lng : element.longitude
            })
            if(index == this.currentHistory.length -1){
                //this.displayDuplicatePos();

                setTimeout(() =>{
                    //FIT BOUNDS AUTO ZOOM AND CENTER
                    var bounds = new google.maps.LatLngBounds();
                    for (var i = 0; i < markersArray.length; i++) {
                        var position = markersArray[i].position;
                        bounds.extend(position);
                    }
                    this.historyMap.fitBounds(bounds);
                    this.historyMap.panToBounds(bounds);
                }, 500);
                
            }
        });

        console.log(this.currentHistory);

        //POLYLINE
        //STROKE ICON
        const direction = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            rotation: 180,
        };
        //GMAP POLYLINE OPTIONS
        const polyLineOpt = new google.maps.Polyline({
            path: polyLatLng,
            icons: [
                {
                    icon: direction,
                    repeat: "70px",
                    
                }
            ],
            geodesic: true,
            strokeColor: "#03A9F4",
            strokeOpacity: 1.0,
            strokeWeight: 1,
        });
        //ADD POLYLINE
        polyLineOpt.setMap(this.historyMap);
    }
     
    goToMarker(event, lat, lng, marker){
        //REMOVE ACTIVE CLASS
        document.querySelectorAll(".historyLine").forEach(element=>{
            element.classList.remove("histo-active");
        });
        //ADD ACTIVE CLASS TO TARGET
        event.currentTarget.classList.add("histo-active");
        //this.historyMap.setCenter(new google.maps.LatLng(lat, lng));
        google.maps.event.trigger(marker, 'click', 'fromList');

    }

    resetHistoryFields(){
        this.currentHistory = [];
        this.histoStart = moment().format("YYYY-MM-DD");
        this.histoEnd = moment().format("YYYY-MM-DD");
        this.histoWifi = true;
        this.histoAtlas = false;
        this.histoCount = 0;
    }

    displayDuplicatePos(){
        this.currentHistory.forEach((element) =>{
            if(element.display == "none" && this.histoPosDisplay && element.color == "#1F3C8F"){
                element.display = "block";
            }else if(element.display == "block" && !this.histoPosDisplay && element.color == "#1F3C8F"){
                element.display = "none";
            }
        });
    }

    refreshToken(){
        this.loading = true;
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
        };
        let body = {
            refreshToken: localStorage.getItem("refreshToken")
        };
        this.http.post<any>('https://admin.iot-tracking.com/api/v2/auth/token/refresh', body ,{headers}).subscribe((data) => {
            this.loading = false;
            localStorage.accessToken = data.token.accessToken;
            this.getDevices();
        }, (error) => {
            this.loading = false;
            console.log(error);
        });
    }

    logout(){
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
        };
        let body = {
            refreshToken: localStorage.getItem("refreshToken")
        };
        this.http.post<any>('https://admin.iot-tracking.com/api/v2/auth/token/reject', body ,{headers}).subscribe((data) => {
            localStorage.clear();
            this.router.navigate(['login'], { queryParams: { logout: true } });
        }, (error) => {
            console.log(error);
        });
    }

    searchValue(){
        let searchCard:any = document.querySelectorAll(".card-cont");
        searchCard.forEach(element =>{
            if(element.innerText.toLowerCase().includes(this.search.toLowerCase())){
                element.style.display = "block";
            }
            else{
                element.style.display = "none";
            }
        });
    }

    searchValueSingleMap(){
        let searchLine:any = document.querySelectorAll(".single-map-row");
        searchLine.forEach(element =>{
            if(element.innerText.toLowerCase().includes(this.searchSingleMap.toLowerCase())){
                element.style.display = "list-item";
            }
            else{
                element.style.display = "none";
            }
        });
    }

    setDevSelected(devToSelect, devIdx){
        this.currSelectedDev = devToSelect;
        this.singleMap.setZoom(18);
        this.singleMap.panTo(this.allSingleMarkers[devIdx].position);
        if(this.singlePanorama != "" && this.singlePanorama != null){
            this.singlePanorama.setVisible(false);
        }
    }

    showLabel(devIdx){
        let tmpLabel = "label"+devIdx;
        let tmpName = "name"+devIdx;
        let tmpActions = "actions"+devIdx;
        let tmpLabelObj = document.getElementById(tmpLabel);
        let tmpNameObj = document.getElementById(tmpName);
        let tmpActionsObj = document.getElementById(tmpActions);

        tmpLabelObj.style.left = "0px";
        tmpNameObj.style.marginLeft = "35px";
        tmpActionsObj.style.marginLeft = "35px";
    }

    hideLabel(devIdx){
        let tmpLabel = "label"+devIdx;
        let tmpName = "name"+devIdx;
        let tmpActions = "actions"+devIdx;
        let tmpLabelObj = document.getElementById(tmpLabel);
        let tmpNameObj = document.getElementById(tmpName);
        let tmpActionsObj = document.getElementById(tmpActions);

        tmpLabelObj.style.left = "-35px";
        tmpNameObj.style.marginLeft = "0px";
        tmpActionsObj.style.marginLeft = "0px";
    }

    showActions(devIdx, locationSource){
        let allActions = document.getElementsByClassName('single-map-actions');
        let allLabels = document.getElementsByClassName('pos-type-label');
        for(var g = 0; g < allActions.length; g++){
            (<HTMLElement>allActions[g]).style.height = "0px";
            (<HTMLElement>allLabels[g]).style.lineHeight = "25px";
        }
        let tmpActions = "actions"+devIdx;
        let tmpLabel = "label"+devIdx;
        let tmpActionsObj = document.getElementById(tmpActions);
        let tmpLabelObj = document.getElementById(tmpLabel);
        if(locationSource == 'data_wifi'){
            let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            if(width<920 && width >768){
                tmpActionsObj.style.height = "80px";
            }else if (width<1370 && width >920){
                tmpActionsObj.style.height = "70px";
            }else{
                tmpActionsObj.style.height = "50px";
            }
            
        }else{
            tmpActionsObj.style.height = "25px";
        }
        
        tmpLabelObj.style.lineHeight = "50px";
    }

    toggleSingleStreetView(objLat, objLon){
        var myLatlng = new google.maps.LatLng(objLat, objLon);

        this.singlePanorama = this.singleMap.getStreetView()!;
        this.singlePanorama.setPosition(myLatlng);
        this.singlePanorama.setPov(
            /** @type {google.maps.StreetViewPov} */ {
            heading: 265,
            pitch: 0,
        });

        const toggle = this.singlePanorama.getVisible();

        if (toggle == false) {
            this.singlePanorama.setVisible(true);
        } else {
            this.singlePanorama.setVisible(false);
        }
    }

    editDevice(deviceID){
        this.loading = true;
        let headers = {'Authorization': 'Bearer ' + localStorage.getItem("accessToken")};
        this.http.get<any>('https://admin.iot-tracking.com/api/v2/devices/'+deviceID+'?locale=fr', {headers}).subscribe((data) => {
            this.currentEditDevice = data;
            this.editDeviceName = data.name;

            this.loading = false;
        }, (error) => {
            if(error.status == 401){
                this.loading = false;
                //this.refreshToken();
                this.logout();
            }
            if(error.status == 500){
                this.loading = false;
            }
        });
    }

    saveDeviceDetails(){
        if(this.currentEditDevice != "" && this.currentEditDevice != null && this.editDeviceName != "" && this.editDeviceName != null){
            this.currentEditDevice.name = this.editDeviceName;
            this.loading = true;
            let headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+ localStorage.getItem("accessToken")
            };
            let body = this.currentEditDevice;
            this.http.put<any>('https://admin.iot-tracking.com/api/v2/devices/'+this.currentEditDevice.id+'?locale=fr', body ,{headers}).subscribe((data) => {
                this.loading = false;
                this.updateDevicesData();
                $('#editDeviceModal').modal('hide');
            }, (error) => {
                this.loading = false;
                console.log(error);
            });
        }
    }

    displayActions(index){
        let actions = document.querySelectorAll(".action-pane");
        actions.forEach(elmt => {
            let element:any = elmt;
            if(element.id != "action-pane-"+index){
                element.style.opacity = "0";
            }
        });
        if(document.getElementById("action-pane-"+index).style.opacity == "1"){
            document.getElementById("action-pane-"+index).style.opacity = "0";
        }else{
            document.getElementById("action-pane-"+index).style.opacity = "1"
        }
    }
    showMacAdress(index){
        let cardMacSection:any = document.querySelector(".device-"+index+"-mac");
        cardMacSection.style.opacity = 1;
        setTimeout(function() {
            cardMacSection.style.opacity = 0;
        }, 60000);
    }
}
